// extracted by mini-css-extract-plugin
export var container = "bZ_t";
export var fadeDiv = "bZ_cn";
export var placeholderWrapper = "bZ_h5";
export var video = "bZ_h6";
export var videoWrapper = "bZ_gg";
export var vimeoPlayer = "bZ_h7";
export var wrapper = "bZ_h";